import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import DashLoadStatusViewForm from './DashLoadStatusViewForm'
import DashLoadStatusAddForm from './DashLoadStatusAddForm'
import DashLoadStatusEditForm from './DashLoadStatusEditForm'
import Namespace from 'src/constants/locale/Namespace'
import DashLoadStatusKeys from 'src/constants/locale/key/ForwardHub'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      UiComponentKeys,
    },
  },
} = constants

const { CngTabs } = components

function AddPage({ history, showNotification }) {
  const [lockedOnFirstTab, setLockedOnFirstTab] = useState(true)
  const [dashLoadStatusId, setDashLoadStatusId] = useState('')
  const { translate } = useTranslation([
    Namespace.DASH_LOAD_STATUS,
    Namespace.UI_COMPONENT
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let dashLoadStatus = translate(
      Namespace.DASH_LOAD_STATUS,
      DashLoadStatusKeys.TITLE
    )
    let tabLockedMessage = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Tabs.PLEASE_SUBMIT_FIRST,
      {
        title: dashLoadStatus
      }
    )

    return {
      dashLoadStatus,
      tabLockedMessage
    }
  }

  function makeDashLoadStatusForm() {
    if (dashLoadStatusId === '') {
      return (
        <DashLoadStatusAddForm
          history={history}
          showNotification={showNotification}
          onPostSubmitSuccess={(datum) => {
            setDashLoadStatusId(datum.id)
            setLockedOnFirstTab(false)
          }}
        />
      )
    } else {
      return (
        <DashLoadStatusEditForm
          showNotification={showNotification}
          id={dashLoadStatusId}
        />
      )
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <DashLoadStatusViewForm
              showNotification={showNotification}
              id={dashLoadStatusId}
            />
          </Container>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.dashLoadStatus,
              tabContent: makeDashLoadStatusForm()
            },
          ]}
          lockedOnFirstTab={lockedOnFirstTab}
          tabLockedMessage={translatedTextsObject.tabLockedMessage}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage